export enum CustomerStatus {
    Active = 0,
    Inactive = 1
}

export const CustomerStatusMetadata = {
    '0': {
        display: 'Active',
        value: 0
    },
    '1': {
        display: 'Inactive',
        value: 1
    }
};
